import Page from "./Page"

document.addEventListener('DOMContentLoaded', (e) => {
  const page = new Page(document.body);
  page.mount();
});
